import { render } from "./LicenciaShow.vue?vue&type=template&id=db3a00d2"
import script from "./LicenciaShow.vue?vue&type=script&lang=js"
export * from "./LicenciaShow.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__